import { FC, useMemo } from 'react'

import './LegacySkeleton.scss'


interface SkeletonProps {
    itemWidthRem: number;
    itemWidthVariation?: number;
    itemCount?: number;
    className?: string;
    itemClassName?: string;
}

interface SkeletonItem {
    id: number;
    width: number;
}

const getStableVariationFactor = (
    index: number,
    itemCount: number,
    itemWidthRem: number,
    itemWidthVariation: number,
): number => {
    const seed = (index + 1) * 13 + itemCount * 7 + itemWidthRem * 17 + itemWidthVariation * 19
    return Math.abs(Math.sin(seed))
}

const LegacySkeleton:FC<SkeletonProps> = ({
    itemCount = 1,
    itemWidthRem,
    itemWidthVariation = 0,
    className = '',
    itemClassName = '',
}) => {
    const items: SkeletonItem[] = useMemo(
        () => new Array(itemCount)
            .fill(null)
            .map((item, index) => ({
                id: index,
                width: itemWidthRem + (itemWidthRem * (getStableVariationFactor(index, itemCount, itemWidthRem, itemWidthVariation) * itemWidthVariation)),
            })),
        [itemCount, itemWidthRem, itemWidthVariation],
    )

    return (
        <div className={`skeleton ${className}`}>
            {
                items.map((item, index) => (
                    <div
                        className={`skeleton__item ${itemClassName}`}
                        key={item.id}
                        style={{
                            width: `${item.width}rem`,
                            animationDelay: `${index * 0.25}s`,
                        }}
                    />
                ))
            }
        </div>
    )
}

export default LegacySkeleton
